module.exports = __webpack_public_path__ + "static/media/due-port09.8318eae8.jpg";